

















import { Prop, Component, Vue } from 'vue-property-decorator';
import { OutfitTypeEnum } from '@/enum/outfit_type';
import GarmentSectionOptions from '@/services/GarmentSectionOptions';

@Component
export default class FashionHeader extends Vue {
  visible = false;
  observer = null;

  @Prop(String) readonly headerBackgroundUrl: string | undefined;
  @Prop(String) readonly headerLogoUrl: string | undefined;
  @Prop(Number) readonly brandId: number | undefined;
  @Prop(Number) readonly outfitType: number | undefined;

  get fashionLogoSize(): string {
    const ralphLaurenInOutfitSection =
      this.outfitType === OutfitTypeEnum.ORIGINAL &&
      this.brandId === GarmentSectionOptions.ralphLaurenBrandOutfitId;
    const ralphLaurenInMixAndMatchSection =
      this.outfitType === OutfitTypeEnum.SPLIT &&
      this.brandId &&
      GarmentSectionOptions.ralphLaurenBrandMixAndMatchIdList.indexOf(this.brandId) !== -1;
    if (ralphLaurenInOutfitSection || ralphLaurenInMixAndMatchSection) {
      return '55%';
    }
    return '85%';
  }
}
